<template lang="pug">
	.project-settings(v-if="showed && project")
		.card
			.card-header
				i.fa.fa-edit
				span Project Settings
			.card-body.collapse.show
				.form-horizontal
					.form-group.separator
						label.col-form-label Title of the project
							.controls
								input.form-control.title(size="16" type="text" v-model="title" @input="updateTitle")
					.form-group
						label.col-form-label Project markers
						.marker-list
							button.project-marker.btn(:class="{'btn-outline-dark': !_.includes(project.options.markers, marker), 'btn-primary': _.includes(project.options.markers, marker)}" type="button" @click="changeProjectMarker(marker)" v-for="(markerData, marker) in publisher.options.projectMarkers") {{marker}}
					.form-group.form-hide.separator
						label Show only in these markers menu
						label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
							input.switch-input.form-check-input(type="checkbox" :checked="project.options['showOnlyInMarkersMenu']" @change="saveOption('showOnlyInMarkersMenu', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
					.form-actions
						button.btn.btn-danger(v-if="canDeleteProject() && project" type="button" @click="deleteProject()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Delete project'}")
							i.fa.fa-remove
							span Delete
						button.btn.btn-dark(type="button" @click="hide()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen';

	import { Project } 			from '../../services/Project';
	import { Version } 			from '../../services/Version';
	import { Settings } 		from '../../services/Settings';

	export default {
		name: "ProjectSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Project Markers Changed",
				"Selected Project End Card Markers Changed"
			]
		},
		data() {

			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			return {
				title: ''
			}
		},
		methods: {
			collectData() {

				if (!Project.SelectedProject) return;

				this.project = Project.SelectedProject;
				this.title = this.getProjectTitle();
				this.publisher = Publisher.Publishers[this.project['publisher_id']];

			},
			updateTitle() {

				Server.sendWithTimeout({
					RenameProject: {
						projectId: this.project.id,
						title: this.title.trim()
					}
				}, null, 200);

			},
			getProjectTitle() {

				return this.project?.title || '';

			},
			changeProjectMarker(projectMarkerName) {

				if (_.includes(this.project.options.markers, projectMarkerName)) {

					Server.sendToServer({
						UnsetProjectMarker: {
							projectId: this.project.id,
							projectMarkerName: projectMarkerName
						}
					});

				} else {

					Server.sendToServer({
						SetProjectMarker: {
							projectId: this.project.id,
							projectMarkerName: projectMarkerName
						}
					});

				}

			},
			saveOption(optionName, newData) {

				this.project.options[optionName] = newData;

				Server.sendWithTimeout({
					UpdateProjectOptions: {
						projectId: this.project.id,
						[optionName]: this.project.options[optionName]
					}
				}, null, 300);

			},
			canDeleteProject() {

				if (User.currentUser.Tags['admin'] || User.currentUser.Tags['publisher-admin']) return true;

				return (this.publisher && this.publisher.options && this.publisher.options['canDeleteProjects']);

			},
			deleteProject() {

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

				Broadcast.call("Show ProjectActionsDelete", []);

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.project-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 500px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input.title
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

			.btn-danger

				i
					margin-right: 10px


			.switch-slider
				background-color: #343b41
				border: 1px solid #23282c

		.form-hide
			display: flex
			flex-direction: row

		.form-group
			display: flex
			flex-direction: column

		.marker-list
			display: flex
			flex-direction: row
			margin-bottom: 0px

			button.project-marker
				margin-right: 10px

		.multi-select-checkbox
			margin-bottom: 10px
			margin-right: 20px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.form-actions
			display: flex
			flex-direction: row
			justify-content: space-between
			margin-top: 20px

</style>

